import {Container, Grid2} from "@mui/material";
import {makeStyles} from "@mui/styles";
import React from "react";
import {adminStyles} from "../styles";
import SettingsTagList from "./SettingsTagList";
import TagSearch from "./TagSearch";
import {connect} from "react-redux";
import globalActions from "components/global/logic/actions";

const useStyle = makeStyles(adminStyles);


function TagHomeComponent() {
    const classes = useStyle();

    const tagSearch = <TagSearch />;

    return (
        (<Container maxWidth={"xl"} className={`atsGlobalContainer ${classes.root}`}>
            <Grid2 container spacing={5}>
                <Grid2 sx={{ display: { sm: "none", xs: "none", md: "none", xl: "block", lg: "block" } }}
                    size={{
                        md: 4,
                        lg: 3,
                        xl: 2
                    }}>
                    {tagSearch}
                </Grid2>

                <Grid2
                    size={{
                        xs: 8,
                        lg: 9,
                        xl: 10
                    }}>
                    <SettingsTagList />
                </Grid2>
            </Grid2>
        </Container>)
    );
}
const TagHome = connect(

    ({globalApp }) => ({
        globalSearchOpen: globalApp.globalSearchOpen,
    }),
    (dispatch) => ({
        onCloseGlobalSearch: () => dispatch(globalActions.TOGGLE_GLOBAL_SEARCH_BTN.call(false)),
    })
)(TagHomeComponent);
export default TagHome;
